import React from 'react'

import { TilesContainer, TilesInner } from './style'

import Button from '../button'
import GlobalContainer from '../globalContainer'
import Typography from '../typography'

// helpers
import ImgUtil from '../../../utils/img.utils'
import { internalLinkHandler, isExternalURL } from '../../../utils/link.utils'
import { renderRichText } from '../../../utils/richTextHandler.utils'
import formatInlineCode, {
  addClassToFirstElementOfReadOnlyJSX,
  addClassToLastElementOfReadOnlyJSX,
} from '../../../utils/shortTextFormatting'
import WrapperImage from '../wrapperImage'

const Tiles = (props: any) => {
  if (props.data) {
    let numberOfColumns = props.data.numberOfColumns ? props.data.numberOfColumns : '3'
    let tiles = props.data.tiles ? props.data.tiles : ''
    let useCase = props.data.useCase ? props.data.useCase : 'Icon'
    let topPadding = props.data.topPadding ? props.data.topPadding : ''
    let bottomPadding = props.data.bottomPadding ? props.data.bottomPadding : ''

    let gridColumnsClass = numberOfColumns == 3 ? 'Tiles__Item--ThreeCol' : 'Tiles__Item--FourCol'

    const twoTiles = tiles.length === 2

    return (
      <TilesContainer topPadding={topPadding} bottomPadding={bottomPadding} data-cy="Tiles">
        <GlobalContainer>
          <TilesInner
            className={gridColumnsClass}
            useCase={useCase}
            twoTiles={twoTiles}
            numberOfColumns={numberOfColumns}>
            {tiles &&
              tiles.map((tile: any, i: number) => {
                let title = tile.title ? tile.title : ''
                let cta = tile.tileCta ? tile.tileCta : ''
                let cta2 = tile.tileCta2 ? tile.tileCta2 : ''
                let orangeTheme = tile.theme ? tile.theme : ''
                let text = tile.text ? tile.text : ''
                let rtfText = tile.rtfText ? tile.rtfText : ''
                let finePrint = tile.finePrint ? tile.finePrint : ''
                let tileUseCase = tile.useCase ? tile.useCase : ''
                let image = ''
                let imageAlt = ''
                if (tile.tileMedia) {
                  if (tile.tileMedia.altText) imageAlt = tile.tileMedia.altText
                  if (
                    tile.tileMedia.image &&
                    tile.tileMedia.image.file &&
                    tile.tileMedia.image.file.url
                  )
                    image = tile.tileMedia.image.file.url
                }

                let linkTarget = '_self'
                if (cta && cta.externalUrl && !cta.internalLink && isExternalURL(cta.externalUrl)) {
                  linkTarget = '_blank'
                }

                let formattedTitle

                if (title) {
                  formattedTitle = formatInlineCode(title)
                  // pricing tiles fineprint inline formatter
                  if (Array.isArray(formattedTitle)) {
                    addClassToFirstElementOfReadOnlyJSX(formattedTitle, 'block-formatter')
                    addClassToLastElementOfReadOnlyJSX(formattedTitle, 'inline-formatter')
                  }
                }

                const classes =
                  tileUseCase === 'Pricing'
                    ? 'Tiles__Card-Link Tiles__Card-Link--Pricing'
                    : 'Tiles__Card-Link'

                return (
                  <a
                    className={classes}
                    href={
                      cta.internalLink ? internalLinkHandler(cta.internalLink) : cta.externalUrl
                    }
                    target={linkTarget}
                    key={`TileItem--${i}`}>
                    <div
                      className={`Tiles__Item ${orangeTheme ? 'Tiles__Orange_Theme' : ''}`}
                      key={i}>
                      {image && (
                        <div className="Tiles__Image-Container">
                          {useCase === 'Logo' && (
                            <>
                              <div className="Tiles__Dots--Top"></div>
                              <div className="Tiles__Dots--Bottom"></div>
                            </>
                          )}
                          <WrapperImage
                            src={ImgUtil.getResizedImageUrl(image, '')}
                            alt={imageAlt}
                            height={32}
                            width={32}
                            threshold={650}
                          />
                        </div>
                      )}
                      {title && (
                        <Typography className="Tiles__Item-Title" type="label">
                          {formattedTitle}
                          {finePrint && (
                            <Typography className="Tiles__Item-FinePrint" type="caption">
                              {finePrint}
                            </Typography>
                          )}
                        </Typography>
                      )}

                      {text && !rtfText && (
                        <Typography className="Tiles__Item-Text" type="bodyXS">
                          {text}
                        </Typography>
                      )}

                      {rtfText && (
                        <Typography type="bodyXS" className="Tiles__Item-RFT-Text">
                          {renderRichText(rtfText)}
                        </Typography>
                      )}
                      {cta &&
                        cta.text &&
                        (tileUseCase === 'Pricing' ? (
                          <Button
                            icon={true}
                            href={
                              cta.internalLink
                                ? internalLinkHandler(cta.internalLink)
                                : cta.externalUrl
                            }
                            text={cta.text}
                            type="secondary"
                            size="small"
                            theme={orangeTheme ? 'dark' : 'light'}
                            className="Tiles__CTA1"
                            useCase={tileUseCase}
                          />
                        ) : (
                          <Button
                            icon={true}
                            href={
                              cta.internalLink
                                ? internalLinkHandler(cta.internalLink)
                                : cta.externalUrl
                            }
                            text={cta.text}
                            type="text-link"
                            size="small"
                            theme={'light'}
                          />
                        ))}

                      {orangeTheme && cta && cta2 && (
                        <Button
                          icon={true}
                          href={
                            cta2.internalLink
                              ? internalLinkHandler(cta2.internalLink)
                              : cta2.externalUrl
                          }
                          text={cta2.text}
                          type="text-link"
                          size="small"
                          theme={'dark'}
                          className="Tiles__CTA2"
                        />
                      )}
                    </div>
                  </a>
                )
              })}
          </TilesInner>
        </GlobalContainer>
      </TilesContainer>
    )
  } else {
    return null
  }
}

export default Tiles
